/* eslint-disable @typescript-eslint/no-explicit-any */
import MiiaFwConfig from '@/configs/config'
import type {
  QueryDisastersRequestParam,
  QueryDisastersResponseParam
} from '@/types/accessor/api/disaster/disaster'
import { useApiGw } from '@/modules/miiaFw/composables/useApiGw'

export const queryDisasters = async (
  arg: QueryDisastersRequestParam
): Promise<QueryDisastersResponseParam> => {
  return await new Promise((resolve, reject) => {
    const { invokeApiGwFunc } = useApiGw()
    invokeApiGwFunc(
      // API Gatewayのエンドポイント
      MiiaFwConfig.config.apiGwEndpointOperation,
      // Lambda関数をコールするためのWebAPIのサブディレクトリ
      '/disasters',
      // Lambda関数に渡す引数
      {
        function: 'query',
        params: arg
      },
      // Lambda関数実行前の前処理のコールバック
      () => {},
      // 成功時のコールバック
      (response: QueryDisastersResponseParam) => {
        resolve(response)
      },
      // 例外受信時のコールバック(引数: エラーメッセージ)
      (message: any) => {
        reject({ message: message })
      },
      // 予期せぬエラー(アクセス回線障害など)発生時のコールバック
      () => {
        reject({ message: 'API実行に失敗しました。(原因: アクセス回線障害など)' })
      },
      // 処理完了後に実行するコールバック
      () => {}
    )
  })
}
